import { MdOutlineEdit, MdOutlineFolder } from "react-icons/md";
import { Content } from "./styles";

interface IImageComponent {
  label: string;
  isCurrent: boolean;
  alreadyFinished: boolean;
}

const ImageComponent: React.FC<IImageComponent> = ({
  label,
  isCurrent,
  alreadyFinished,
}: IImageComponent) => {
  const labelToDisplay = () => {
    const ICON_SIZE = 20;
    const ICON_COLOR = isCurrent
      ? "#FFF"
      : alreadyFinished
      ? "#6EA6FF"
      : "#B5B2C0";

    switch (label) {
      case "Upload":
        return <MdOutlineFolder size={ICON_SIZE} color={ICON_COLOR} />;
      case "Signatários":
        return <MdOutlineEdit size={ICON_SIZE} color={ICON_COLOR} />;
      default:
        return <MdOutlineFolder size={ICON_SIZE} color={ICON_COLOR} />;
    }
  };

  return (
    <Content>
      <div
        id={
          isCurrent
            ? "current-step-image"
            : alreadyFinished
            ? "finished-step-image"
            : "future-step-image"
        }
      >
        {labelToDisplay()}
      </div>
      <span
        id={
          isCurrent
            ? "current-step-label"
            : alreadyFinished
            ? "finished-step-label"
            : "future-step-label"
        }
      >
        {label}
      </span>
    </Content>
  );
};

export default ImageComponent;
